import HomeView from '@/views/HomeView.vue'
import ScanView from '@/views/ScanView.vue'
import WineDetailView from '@/views/WineDetailView.vue'
import WineListView from '@/views/WineListView.vue'
import WineReviewView from '@/views/WineReviewView.vue'

import { useUiStore } from '@/stores/ui'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/wines',
        name: 'wines',
        component: WineListView,
    },
    {
        path: '/wine_review/:id',
        name: 'wine-review',
        component: WineReviewView,
        props: true,
    },
    {
        path: '/wine_info/:id',
        name: 'wine-info',
        component: WineDetailView,
        props: true,
    },
    {
        path: '/scan',
        name: 'scan',
        component: ScanView,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        // Всегда скроллим к верху страницы при переходе
        return { top: 0, left: 0 }
    },
})

router.beforeEach((_to, _from, next) => {
    const ui = useUiStore()
    ui.startRouteLoading()
    next()
})

router.afterEach(() => {
    const ui = useUiStore()
    // небольшая задержка, чтобы избежать мерцаний на быстрых переходах
    setTimeout(() => ui.stopRouteLoading(), 800)
})

export default router
